/**
 * 권한 집합 계산 — 부서 권한 / 개인 권한 / 유효 권한 사이의 규칙.
 *
 * <p>모달 컴포넌트 안에 두면 렌더링 없이는 검증할 수 없어서 따로 뺐다. 여기 규칙이 틀리면
 * "저장했는데 권한이 사라졌다" 같은, 화면만 봐서는 원인을 못 찾는 버그가 된다.
 */

/** Set | 배열 | null 을 Set 으로 통일. */
export const toCodeSet = (v) =>
    v instanceof Set ? new Set(v) : new Set(Array.isArray(v) ? v : []);

/** 유효 권한 = 부서 ∪ 개인. 실제로 쓸 수 있는 권한이 무엇인지. */
export const unionCodes = (deptCodes, personalCodes) =>
    new Set([...toCodeSet(deptCodes), ...toCodeSet(personalCodes)]);

/**
 * 권한 트리의 체크 결과(next) → 저장할 개인 권한 집합.
 *
 * <p>트리는 "부서 ∪ 개인"을 한 덩어리로 보여주고 부서 권한은 잠가둔다. 그래서 next 만 봐서는
 * 어떤 코드가 개인 권한이었는지 알 수 없다 — 부서와 겹치는 개인 권한은 잠겨서 토글되지 않으므로
 * 이전 상태(prevPersonal)에서 그대로 살려야 한다.
 *
 * <p>이 보존을 빼먹으면 부서와 겹치는 개인 권한이 저장할 때마다 조용히 회수된다. 평소엔 부서가
 * 같은 권한을 주고 있어 티가 안 나다가, 나중에 부서를 옮기거나 부서 권한을 줄이는 순간
 * "원래 있던 개인 권한"까지 함께 사라진다.
 *
 * @param {Set<string>|string[]} next         트리가 돌려준 전체 체크 집합(부서 ∪ 개인)
 * @param {Set<string>|string[]} deptCodes    현재 선택된 부서의 자동 권한
 * @param {Set<string>|string[]} prevPersonal 직전 개인 권한 집합
 * @returns {Set<string>} 저장할 개인 권한 집합
 */
export function personalFromTreeSelection(next, deptCodes, prevPersonal) {
    const nextSet = toCodeSet(next);
    const deptSet = toCodeSet(deptCodes);
    const prevSet = toCodeSet(prevPersonal);

    const out = new Set();
    for (const c of nextSet) if (!deptSet.has(c)) out.add(c);
    for (const c of prevSet) if (deptSet.has(c)) out.add(c);   // 부서에 가려진 개인 권한 보존
    return out;
}
